import { useContext, useReducer } from "react";
import { Outlet } from "react-router-dom";
import { packagesReducer } from "./packagesReducer";
import { packagesInitialState } from "./packagesInitialState";
import PackagesContext from "./PackagesContext";


export const usePackagesContext = () => useContext(PackagesContext)


export function PackagesProvider() {
    const [packagesState, packagesDispatch] = useReducer(
        packagesReducer,
        packagesInitialState
    )

    return (
        <PackagesContext.Provider value={{ packagesState, packagesDispatch }}>
            <Outlet />
        </PackagesContext.Provider>
    )
}
